module.exports = __webpack_public_path__ + "static/performanceplatform-6d80b0d13eec106b8800f3172f087264.jpg";